export default "__VITE_ASSET__B5Iyzb$H__"